import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { tokenInterceptor } from './interceptor/token-interceptor';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideSweetAlert2 } from '@sweetalert2/ngx-sweetalert2';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Custom TranslateLoader with cache busting
export class CacheBustingTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    const timestamp = new Date().getTime();
    return this.http.get(`./assets/i18n/${lang}.json?v=${timestamp}`);
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new CacheBustingTranslateLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([tokenInterceptor])),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideNativeDateAdapter(),
    provideSweetAlert2(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'lo',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
  ],
};
